import script from "./ProjectExternalDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectExternalDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectExternalDashboard.vue?vue&type=style&index=0&id=342a476a&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-342a476a"]])

export default __exports__